/* ============================================================
   GBRS GROUP — Assaulter Belt Bundle Landing Page
   Shopify Asset: gbrs-bundle.js
   ============================================================ */

(function () {
  'use strict';

  const root = document.querySelector('.gbrs-lp');
  if (!root) return;

  /* ---- FADE-IN ON SCROLL ---- */
  const observer = new IntersectionObserver(
    (entries) => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('gbrs-visible'); observer.unobserve(entry.target); }
    }),
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );
  root.querySelectorAll('.gbrs-fade-in').forEach(el => observer.observe(el));

  /* ---- COLOR GALLERY LIGHTBOX ---- */
  root.querySelectorAll('.gbrs-gallery-item').forEach(item => {
    item.addEventListener('click', () => {
      const img = item.querySelector('img');
      if (img) openLightbox(img.src, img.alt);
    });
  });

  function openLightbox(src, alt) {
    const overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,0.92);display:flex;align-items:center;justify-content:center;cursor:zoom-out;';
    const img = document.createElement('img');
    img.src = src; img.alt = alt;
    img.style.cssText = 'max-width:90vw;max-height:90vh;object-fit:contain;border-radius:4px;box-shadow:0 8px 64px rgba(0,0,0,0.8);';
    const closeBtn = document.createElement('button');
    closeBtn.textContent = '×';
    closeBtn.style.cssText = 'position:absolute;top:20px;right:28px;background:none;border:none;color:#fff;font-size:40px;cursor:pointer;line-height:1;opacity:0.7;';
    overlay.appendChild(img); overlay.appendChild(closeBtn);
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
    function close() { if (document.body.contains(overlay)) document.body.removeChild(overlay); document.body.style.overflow = ''; }
    overlay.addEventListener('click', e => { if (e.target === overlay || e.target === closeBtn) close(); });
    document.addEventListener('keydown', function onKey(e) { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', onKey); } });
  }

  /* ---- SMOOTH ANCHOR SCROLL ---- */
  root.querySelectorAll('a[href^="#gbrs-"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      const headerEl = document.querySelector('.site-header, header.header, #shopify-section-header');
      const offset = headerEl ? headerEl.offsetHeight + 16 : 80;
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' });
    });
  });

  /* ============================================================
     VARIANT SELECTOR MODAL
     ============================================================ */

  const modal        = document.getElementById('gbrsVariantModal');
  const modalClose   = document.getElementById('gbrsModalClose');
  const colorOptions = document.querySelectorAll('#gbrsVariantModal .gbrs-variant-option--color');
  const sizeOptions  = document.querySelectorAll('#gbrsVariantModal .gbrs-variant-option--size');
  const colorLabel   = document.getElementById('gbrsColorSelected');
  const sizeLabel    = document.getElementById('gbrsSizeSelected');
  const atcBtn       = document.getElementById('gbrsModalAtcBtn');
  const errorMsg     = document.getElementById('gbrsModalError');

  // Variant map — populated by fetching Shopify's product JSON endpoint.
  // This bypasses all_products[] which does NOT work on /pages/ templates.
  const productHandle = window.GBRS_PRODUCT_HANDLE || 'gbrs-group-assaulter-belt-bundle';
  const productUrl    = window.GBRS_PRODUCT_URL    || '/products/' + productHandle;

  let variantMap = window.GBRS_VARIANTS || {}; // may be pre-populated by Liquid on product templates
  let variantsReady = Object.keys(variantMap).length > 0;

  // Always fetch fresh from the storefront JSON — works on any template
  fetch('/products/' + productHandle + '.js')
    .then(r => r.json())
    .then(product => {
      variantMap = {};
      product.variants.forEach(v => { variantMap[v.title] = v.id; });
      variantsReady = true;
      console.log('[GBRS] Variants loaded:', Object.keys(variantMap).length, '—', Object.keys(variantMap).join(', '));
    })
    .catch(err => {
      console.warn('[GBRS] Could not fetch product variants:', err);
      // Fall back to whatever Liquid injected (may be empty on page templates)
    });

  let selectedColor = null;
  let selectedSize  = null;

  /* ---- Open / Close ---- */
  function openModal() {
    if (!modal) { console.warn('GBRS: #gbrsVariantModal not found'); return; }
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    // Reset
    selectedColor = null; selectedSize = null;
    colorLabel.textContent = 'Select a color';
    sizeLabel.textContent  = 'Select a size';
    colorOptions.forEach(o => o.classList.remove('is-selected'));
    sizeOptions.forEach(o => o.classList.remove('is-selected'));
    if (errorMsg) errorMsg.textContent = '';
    updateAtcBtn();
    if (modalClose) modalClose.focus();
  }

  function closeModal() {
    if (modal) modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function updateAtcBtn() {
    const ready = selectedColor && selectedSize;
    atcBtn.disabled = !ready;
    atcBtn.textContent = ready
      ? `Add to Cart — ${selectedSize} / ${selectedColor}`
      : 'Add to Cart';
  }

  /* ---- Intercept ALL primary CTA clicks ---- */
  const ctaSelectors = [
    '.gbrs-hero__cta .gbrs-btn--primary',
    '.gbrs-overview-cta .gbrs-btn--primary',
    '.gbrs-included-cta .gbrs-btn--primary',
    '.gbrs-reviews-cta .gbrs-btn--primary',
    '.gbrs-cta__actions .gbrs-btn--primary',
    '#gbrs-sticky-cta a',
    // Also intercept any ATC form submit buttons
    '.gbrs-atc-btn',
  ];
  document.querySelectorAll(ctaSelectors.join(', ')).forEach(btn => {
    btn.addEventListener('click', e => { e.preventDefault(); openModal(); });
  });
  // Prevent ATC forms from submitting directly
  root.querySelectorAll('.gbrs-atc-form').forEach(form => {
    form.addEventListener('submit', e => { e.preventDefault(); openModal(); });
  });

  /* ---- Color selection ---- */
  colorOptions.forEach(option => {
    option.addEventListener('click', () => {
      colorOptions.forEach(o => o.classList.remove('is-selected'));
      option.classList.add('is-selected');
      selectedColor = option.dataset.value;
      colorLabel.textContent = selectedColor;
      if (errorMsg) errorMsg.textContent = '';
      updateAtcBtn();
    });
  });

  /* ---- Size selection ---- */
  sizeOptions.forEach(option => {
    if (option.classList.contains('is-unavailable')) return;
    option.addEventListener('click', () => {
      sizeOptions.forEach(o => o.classList.remove('is-selected'));
      option.classList.add('is-selected');
      selectedSize = option.dataset.value;
      sizeLabel.textContent = selectedSize;
      if (errorMsg) errorMsg.textContent = '';
      updateAtcBtn();
    });
  });

  /* ---- Close triggers ---- */
  if (modalClose) modalClose.addEventListener('click', closeModal);
  if (modal) modal.addEventListener('click', e => { if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) closeModal();
  });

  /* ---- Add to Cart (Shopify AJAX) ---- */
  if (atcBtn) {
    atcBtn.addEventListener('click', () => {
      if (!selectedColor || !selectedSize) {
        if (errorMsg) errorMsg.textContent = 'Please select both a size and color.';
        return;
      }

      if (!variantsReady) {
        if (errorMsg) errorMsg.textContent = 'Loading, please try again in a moment.';
        return;
      }

      // This product has 3 options: Size / Belt Color / Pouch Color
      // Format: "S / Multicam / Multicam"
      // We default pouch color = belt color (matching set), then fall back to any available pouch color.
      const norm = str => str.trim().replace(/\s+/g, ' ');

      let variantId = null;

      // First pass: exact match with pouch = belt color (matching set)
      const preferredKey = norm(`${selectedSize} / ${selectedColor} / ${selectedColor}`);
      for (const [k, v] of Object.entries(variantMap)) {
        if (norm(k) === preferredKey) { variantId = v; break; }
      }

      // Second pass: any available variant with matching size + belt color
      if (!variantId) {
        const sizeColorPrefix = norm(`${selectedSize} / ${selectedColor} /`);
        for (const [k, v] of Object.entries(variantMap)) {
          if (norm(k).startsWith(sizeColorPrefix)) { variantId = v; break; }
        }
      }

      // Third pass: try reversed size/color order (legacy 2-option format)
      if (!variantId) {
        const altKey = norm(`${selectedColor} / ${selectedSize}`);
        for (const [k, v] of Object.entries(variantMap)) {
          if (norm(k) === altKey) { variantId = v; break; }
        }
      }

      if (!variantId) {
        console.warn('[GBRS] No match for size:', selectedSize, 'color:', selectedColor, '— keys:', Object.keys(variantMap).slice(0, 5));
        if (errorMsg) errorMsg.textContent = 'This combination is currently unavailable.';
        return;
      }

      const originalText = atcBtn.textContent;
      atcBtn.textContent = 'Adding to Cart…';
      atcBtn.disabled = true;
      if (errorMsg) errorMsg.textContent = '';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(res => res.json())
      .then(data => {
        if (data.status) {
          // Shopify returned an error
          if (errorMsg) errorMsg.textContent = data.description || 'Something went wrong. Please try again.';
          atcBtn.textContent = originalText;
          atcBtn.disabled = false;
        } else {
          // Success
          atcBtn.textContent = '✓ Added to Cart!';
          atcBtn.style.background = '#27ae60';
          atcBtn.style.color = '#fff';

          // Update cart count badge
          fetch('/cart.js')
            .then(r => r.json())
            .then(cart => {
              document.querySelectorAll([
                '[data-cart-count]', '.cart-count', '#cart-count',
                '.header__cart-count', '.cart-icon-bubble',
                '[data-cart-item-count]', '.cart-count-bubble',
                '.cart-link__bubble',
              ].join(', ')).forEach(el => {
                el.textContent = cart.item_count;
                el.setAttribute('data-count', cart.item_count);
                if (cart.item_count > 0) el.classList.remove('hide', 'hidden', 'is-hidden');
              });
            });

          setTimeout(() => {
            atcBtn.textContent = originalText;
            atcBtn.style.background = '';
            atcBtn.style.color = '';
            atcBtn.disabled = false;
            closeModal();
            // Click the theme cart drawer trigger
            const cartBtn = document.querySelector('.js-drawer-open-cart, [aria-controls="CartDrawer"]');
            if (cartBtn) cartBtn.click();
          }, 1200);
        }
      })
      .catch(() => {
        if (errorMsg) errorMsg.textContent = 'Network error. Please try again.';
        atcBtn.textContent = originalText;
        atcBtn.disabled = false;
      });
    });
  }

  /* ---- MOBILE STICKY CTA ---- */
  if (window.innerWidth <= 768) {
    const sticky = document.createElement('div');
    sticky.id = 'gbrs-sticky-cta';
    sticky.style.cssText = [
      'position:fixed','bottom:0','left:0','right:0','z-index:9000',
      'background:rgba(13,13,13,0.97)',
      'border-top:1px solid #2a2a2a',
      'padding:12px 20px',
      'display:flex','gap:12px','align-items:center',
      'transform:translateY(100%)',
      'transition:transform 0.3s ease',
      'backdrop-filter:blur(12px)'
    ].join(';');
    sticky.innerHTML = `
      <div style="flex:1;">
        <div style="font-family:'Barlow Condensed',sans-serif;font-size:22px;font-weight:800;color:#b19e82;">$399.99</div>
        <div style="font-family:'Barlow Condensed',sans-serif;font-size:12px;color:#8a8680;text-decoration:line-through;">$462.41</div>
      </div>
      <a href="#" style="display:inline-flex;align-items:center;justify-content:center;background:#b19e82;color:#0d0d0d;font-family:'Barlow Condensed',sans-serif;font-size:15px;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;padding:14px 28px;border-radius:4px;text-decoration:none;white-space:nowrap;">
        Shop Now
      </a>
    `;
    document.body.appendChild(sticky);
    sticky.querySelector('a').addEventListener('click', e => { e.preventDefault(); openModal(); });

    const heroCta = root.querySelector('.gbrs-hero__cta');
    if (heroCta) {
      new IntersectionObserver(([entry]) => {
        sticky.style.transform = entry.isIntersecting ? 'translateY(100%)' : 'translateY(0)';
      }, { threshold: 0 }).observe(heroCta);
    }
  }

})();